// IDEA replace with R.deepMergeLeft - remove 'deepmerge' library
// WHEN have time
import deepMergeLib from 'deepmerge'; // Deprecated - use R.deepMergeLeft

export const deepMerge = <T,>(...args: T[]) =>
  args.reduce((accum, curr) => deepMergeLib<T>(accum, curr));
